import { render, staticRenderFns } from "./markdowninput.vue?vue&type=template&id=bf294efe&scoped=true&"
import script from "./markdowninput.vue?vue&type=script&lang=js&"
export * from "./markdowninput.vue?vue&type=script&lang=js&"
import style0 from "./markdowninput.vue?vue&type=style&index=0&id=bf294efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf294efe",
  null
  
)

export default component.exports